import { FolderSelf } from './style';
import FolderIcon from '../../../../assets/icons/folder.svg?react';

const Folder = ({ name, description, ...props }) => {
  return (
    <FolderSelf {...props}>
      <FolderIcon />
      <div className="meta">
        <h3>{name}</h3>
        <p>{description}</p>
      </div>
    </FolderSelf>
  );
};

export default Folder;
